import { render, staticRenderFns } from "./SalesOrder.vue?vue&type=template&id=564a0e98&scoped=true&"
import script from "./SalesOrder.vue?vue&type=script&lang=js&"
export * from "./SalesOrder.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrder.vue?vue&type=style&index=0&id=564a0e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564a0e98",
  null
  
)

export default component.exports